'use strict';
var React = require('react');
module.exports = function () {
    function onClick1() {
        this.props.closeAccountSignUpModal();
    }
    function onChange2(e) {
        this.handleChange(e);
    }
    function onChange3(e) {
        this.handleChange(e);
    }
    function onChange4(e) {
        this.handleChange(e);
    }
    function onClick5(event) {
        this.props.onSubmit(event, Object.assign({}, this.state), this.props.selectedPlans);
    }
    return React.createElement('div', {
        'className': _.transform({
            'account-signup-wrapper': true,
            'plan-signup-wrapper': this.props.planAccountSignup
        }, function (res, value, key) {
            if (value) {
                res.push(key);
            }
        }, []).join(' ')
    }, React.createElement('div', { 'className': 'metype-purchase-container' }, this.props.spinner ? React.createElement('div', {
        'className': 'spinner-main',
        'key': '149'
    }, React.createElement('div', { 'className': 'loader' })) : null, React.createElement('div', {
        'className': 'home-close-button',
        'onClick': onClick1.bind(this)
    }), this.props.currentUser ? React.createElement('div', {
        'className': 'website-detail-wrapper',
        'key': '354'
    }, React.createElement('div', { 'className': 'metype-purchase-logo' }), React.createElement('div', { 'className': 'metype-purchase-text' }, 'Add your first property to continue'), this.props.selectedPlans ? React.createElement('div', {
        'className': 'metype-purchase-description',
        'key': '558'
    }, 'You have selected ', React.createElement('div', { 'className': 'plan-description' }, React.createElement('span', { 'className': 'package-card-price-selected-text' }, this.props.selectedPlans.name, ' - '), React.createElement('span', { 'className': 'package-card-price-selected-text' }, '$', this.props.selectedPlans.price))) : null, React.createElement('form', {}, React.createElement('div', { 'className': 'form-fields' }, React.createElement('label', {
        'className': 'form-fields-label',
        'htmlFor': 'emailAddress'
    }, 'Account email address *'), React.createElement('input', {
        'className': 'form-fields-input',
        'name': 'account_email',
        'id': 'emailAddress',
        'type': 'email',
        'required': true,
        'onChange': onChange2.bind(this)
    })), React.createElement('div', { 'className': 'form-fields' }, React.createElement('label', {
        'className': 'form-fields-label',
        'htmlFor': 'account_name'
    }, 'Account Name*'), React.createElement('input', {
        'className': 'form-fields-input',
        'name': 'account_name',
        'id': 'account_name',
        'type': 'text',
        'onChange': onChange3.bind(this),
        'required': true
    })), React.createElement('div', { 'className': 'form-fields' }, React.createElement('label', {
        'className': 'form-fields-label',
        'htmlFor': 'website_url'
    }, 'Property URL *'), React.createElement('input', {
        'className': 'form-fields-input',
        'name': 'website_url',
        'id': 'website_url',
        'type': 'url',
        'onChange': onChange4.bind(this),
        'required': true
    })), React.createElement('div', { 'className': 'accept-terms-conditions' }, React.createElement('input', {
        'className': 'accept-terms-conditions__checkbox',
        'name': 'terms_and_conditions',
        'id': 'terms_and_conditions',
        'type': 'checkbox',
        'required': true
    }), React.createElement('span', { 'className': 'accept-terms-conditions__link-text' }, 'I accept the ', React.createElement('a', {
        'className': 'legal-links',
        'href': 'https://www.quintype.com/terms',
        'target': '_blank'
    }, 'Terms & Conditions'), '\n                and ', React.createElement('a', {
        'className': 'legal-links',
        'href': 'https://www.quintype.com/privacy-policy',
        'target': '_blank'
    }, 'Privacy Policy'))), React.createElement('button', {
        'type': 'submit',
        'name': 'next',
        'onClick': onClick5.bind(this),
        'id': 'pay-now-button',
        'className': 'next-button' + ' ' + _.transform({ 'disabled-button': this.props.disableGetStartedButton }, function (res, value, key) {
            if (value) {
                res.push(key);
            }
        }, []).join(' ')
    }, this.getButtonText()))) : null));
};


//////////////////
// WEBPACK FOOTER
// ./app/javascript/pages/metype_home/account_signup_modal.rt
// module id = 894
// module chunks = 7